<div>
  <div>
    <fieldset>
      <legend class="required">{{gpFiles && gpFiles.itemCount ? 'Výběr souboru VFK' : 'Vložení GP'}}</legend>
      <div *ngIf="data.geometricPlanRequest && (!gpFiles || gpFiles.itemCount)">
        <div [loading]="true" *ngIf="!gpFiles">
        </div>
        <div *ngIf="gpFiles" class="checklist">
          <div *ngFor="let attachment of gpFiles" class="checklist-item flexbox-container" (click)="gpVfkFile=attachment; vfkFiles.splice(0,vfkFiles.length)">
            <gmt-radio [gmtChecked]="gpVfkFile == attachment"></gmt-radio>
            <div class="pl-20">
              <div class="column-100">
                <label>Název</label>
                <div class="info">
                  <a href="{{restBaseUrl}}/attachments/{{attachment.id}}/data?t={{authToken}}">
                    {{attachment.baseName + (attachment.extension ? '.' + attachment.extension : '')}}
                  </a>
                </div>
              </div>
              <div class="column-100">
                <label>Poznámka</label>
                <div class="info">{{attachment.note}}</div>
              </div>
              <div class="column-100">
                <label>Nahrál</label>
                <div class="info">{{attachment.createdUser | username}}</div>
              </div>
              <div class="column-100">
                <label>Datum nahrání</label>
                <div class="info">{{attachment.timestamp | date : 'short'}}</div>
              </div>
            </div>
          </div>
          <div class="checklist-item" (click)="gpVfkFile=null"><gmt-radio [gmtChecked]="!gpVfkFile"></gmt-radio> Vlastní soubor VFK</div>
        </div>
      </div>
      <fileupload *ngIf="!gpVfkFile" class="blue" [inputId]="'hiddenInput1'" (change)="onChangeFile($event, 'vfk')" [message]="vfkMessage" [files]="vfkFiles"></fileupload>
    </fieldset>

    <fieldset *ngIf="vfkFiles?.length > 0 || gpVfkFile">
      <legend>Nepovinné údaje - hromadné vložení dat GP</legend>
      <fileupload class="yellow" [inputId]="'hiddenInput2'" (change)="onChangeFile($event, 'csv')" [message]="csvMessage" [files]="csvFiles"></fileupload>
    </fieldset>
  </div>
  <div class="mt-10">
    <gmt-button [clickAction]="onSubmit" [gmtDisabled]="!isFormValid()">Další</gmt-button>
  </div>
</div>
